import { Component, OnInit, Renderer2 } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { VerifypatientService } from 'src/app/services/verifypatient.service';
import { VerifypatientModule, PatientPersonalInfo, getPatientDataByURl, auth } from 'src/app/models/verifypatient/verifypatient';
import { getPatientDataByReferralURl, Referral, selectedReferrals } from 'src/app/models/referral/referral';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UpdateinfoService } from 'src/app/services/updateinfo.service';
import { ReferralService } from 'src/app/services/referral.service';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
declare var $: any;

@Component({
  selector: 'app-referral-checkin',
  templateUrl: './referral-checkin.component.html',
  styleUrls: ['./referral-checkin.component.css']
})
export class ReferralCheckinComponent implements OnInit {
  VerifypatientModule: VerifypatientModule;
  PatientPersonalInfo: PatientPersonalInfo;
  getSelectedReferralInfo: selectedReferrals[] = [];
  auth: auth;
  getPatientReferralInfo: getPatientDataByReferralURl = new getPatientDataByReferralURl();
  selectedLanguage: any = 'en';
  selectedDay: any;
  selectedMonth: any;
  selectedYear: any;
  months: string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  years: number[] = [];

  daysInMonth: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
  phoneLink: any;
  isAuthenticated: any = false;
  constructor( private translateService: TranslateService, private _phrutilService: PhrutillsService, private _VerifypatientService: VerifypatientService, private spinner: NgxSpinnerService,
    private route: Router, private updateinfoservice: UpdateinfoService, private referralService: ReferralService, private _route: ActivatedRoute,) {
    this.auth = new auth();
  }
  profileForm = new UntypedFormGroup({
    dobDay: new UntypedFormControl('', [Validators.required]),
    dobMonth: new UntypedFormControl('', [Validators.required]),
    dobyear: new UntypedFormControl('', [Validators.required])
  });


  ngOnInit(): void {
    let lang = localStorage.getItem('language');
    if (lang) {
      this.selectedLanguage = lang;
    } else {

      this.selectedLanguage = 'en'
    }
    this.populateYears();
    console.log("referral component");
    this._route.queryParams.subscribe((params: Params) => {
      localStorage.clear();
      console.log("clearing local storage")
      localStorage.setItem('language', this.selectedLanguage);
      if (params['ref'] != null) {
        console.log('param ', params['ref']);
        //D4Pw3zQ%2FeSv7wd6WvVxCjw%3D%3D
        sessionStorage.setItem("referralLink", params['ref']);
        this.getPatientAndProviderDataForReferral(params['ref']);
      } else {
        $("#invalidLink-model").modal("show");
      } 
    }, error => {
      localStorage.clear();
      $("#invalidLink-model").modal("show");
    });
    localStorage.setItem("isAuth", this.isAuthenticated);
    this._phrutilService.setTitle('referral');

  }
  

  populateYears(): void {
    const currentYear = new Date().getFullYear();
    //const startYear = currentYear - 100;
    const startYear = 1900;
    const endYear = currentYear;

    for (let i = endYear; i >= startYear; i--) {
      this.years.push(i);
    }
  }

  updateDays(event: any) {

    const selectedDay = this.profileForm.controls['dobDay'].value;
    this.selectedMonth = parseInt(this.profileForm.controls['dobMonth'].value, 10);
    this.selectedYear = parseInt(this.profileForm.controls['dobyear'].value, 10) || new Date().getFullYear();

    if (this.selectedMonth) {
      //console.log("inside update days");
      const daysInSelectedMonth = new Date(this.selectedYear, this.selectedMonth, 0).getDate();
      // console.log(daysInSelectedMonth);
      this.daysInMonth = Array.from({ length: daysInSelectedMonth }, (_, i) => i + 1);
      if (selectedDay != '') {
        if (selectedDay > daysInSelectedMonth) {
          this.profileForm.controls['dobDay'].setValue('');
        } else {
          this.profileForm.controls['dobDay'].setValue(selectedDay);
        }
      }

    } else {
      this.daysInMonth = Array.from({ length: 31 }, (_, i) => i + 1);
    }
  }



  referralStatus: any = 'new';
  speciality: any = '';
  responseMessage: any = '';
  getPatientAndProviderDataForReferral(param:any) {

    this.spinner.show();
    this.referralService.getPatientInfoReferralFlow(param).subscribe((res: any) => {

      this.spinner.hide();
      if (res.data) {
       // console.log(res.data.referrals[0].suggesteD_PROVIDER_ID, "suggested providerid");
       // res.message = 'Referral data retrieved from Referral_tracker';
        this.responseMessage = res.message;
        if (res.message.toLowerCase() == 'suggested providers') {
          this.referralStatus = "new";
          localStorage.setItem("refStatus", this.referralStatus);
        } else if (res.message.toLowerCase() == 'the patient has already confirmed a provider') {
          this.referralStatus = "confirm";
          localStorage.setItem("refStatus", this.referralStatus);
        } else if (res.message.toLowerCase() == 'referral has been sent' && res.data.referrals[0].suggesteD_PROVIDER_ID) {
          this.referralStatus = "sent";
          localStorage.setItem("refStatus", this.referralStatus);
        } else if ((this.responseMessage.toLowerCase() == "referral data retrieved from referral_tracker" || this.responseMessage.toLowerCase() == 'referral has been sent') && !res.data.referrals[0].suggesteD_PROVIDER_ID) {
          this.referralStatus = "noSuggestedProvider";
          localStorage.setItem("refStatus", this.referralStatus);
        } else {
          this.referralStatus = "new";
          localStorage.setItem("refStatus", this.referralStatus);
        }
        //console.log("status code ",res.statusCode);
        if (res.statusCode !== '200') {

          //console.log(res.data);
          localStorage.setItem("AuthTokenwebServices", res.data.accessTokenResponse.accessToken);
          sessionStorage.setItem("AuthTokenwebServices", res.data.accessTokenResponse.accessToken);
          localStorage.setItem("RefreashTokenwebServices", res.data.accessTokenResponse.refreshToken);
          this.getPatientReferralInfo.patientAccount = res.data.patientAccount ? this._phrutilService.decryptforServices(res.data.patientAccount) : res.data.patientAccount;
          this.getPatientReferralInfo.firstName = res.data.firstName ? this._phrutilService.decryptforServices(res.data.firstName) : res.data.firstName;
          this.getPatientReferralInfo.lastName = res.data.lastName ? this._phrutilService.decryptforServices(res.data.lastName) : res.data.lastName;
          this.getPatientReferralInfo.dateOfBirth = res.data.dateOfBirth ? this._phrutilService.decryptforServices(res.data.dateOfBirth) : res.data.dateOfBirth;
          this.getPatientReferralInfo.practiceCode = res.data.practiceCode ? this._phrutilService.decryptforServices(res.data.practiceCode) : res.data.practiceCode;
          this.getPatientReferralInfo.practiceName = res.data.practiceName ? this._phrutilService.decryptforServices(res.data.practiceName) : res.data.practiceName;
          this.getPatientReferralInfo.practicePhone = res.data.practicePhone ? this._phrutilService.decryptforServices(res.data.practicePhone) : res.data.practicePhone;
          this.getPatientReferralInfo.city = res.data.city ? this._phrutilService.decryptforServices(res.data.city) : res.data.city;
          this.getPatientReferralInfo.state = res.data.state ? this._phrutilService.decryptforServices(res.data.state) : res.data.state;
          this.getPatientReferralInfo.patientPhone = res.data.patientPhone ? this._phrutilService.decryptforServices(res.data.patientPhone) : res.data.patientPhone;
          this.getPatientReferralInfo.practiceFax = res.data.practiceFax ? this._phrutilService.decryptforServices(res.data.practiceFax) : res.data.practiceFax;
          this.getPatientReferralInfo.speciality = res.data.speciality ? this._phrutilService.decryptforServices(res.data.speciality) : res.data.speciality;
          this.getPatientReferralInfo.practiceAddress = res.data.practiceAddress ? this._phrutilService.decryptforServices(res.data.practiceAddress) : res.data.practiceAddress;
          this.getPatientReferralInfo.address = res.data.address ? this._phrutilService.decryptforServices(res.data.address) : res.data.address;
          this.getPatientReferralInfo.zip = res.data.zip ? this._phrutilService.decryptforServices(res.data.zip) : res.data.zip;
          this.getPatientReferralInfo.ssn = res.data.ssn ? this._phrutilService.decryptforServices(res.data.ssn) : res.data.ssn;

          //console.log(this.getPatientReferralInfo)
          // Handle multiple referrals by looping through each entry
          this.getPatientReferralInfo.referrals = res.data.referrals.map((referral: any) => {
            return {
              suggesteD_PROVIDER_ID: referral.suggesteD_PROVIDER_ID ? this._phrutilService.decryptforServices(referral.suggesteD_PROVIDER_ID) : referral.suggesteD_PROVIDER_ID,
              referraL_ID: referral.referraL_ID ? this._phrutilService.decryptforServices(referral.referraL_ID) : referral.referraL_ID,
              npi: referral.npi ? this._phrutilService.decryptforServices(referral.npi) : referral.npi,
              firsT_NAME: referral.firsT_NAME ? this._phrutilService.decryptforServices(referral.firsT_NAME) : referral.firsT_NAME,
              lasT_NAME: referral.lasT_NAME ? this._phrutilService.decryptforServices(referral.lasT_NAME) : referral.lasT_NAME,
              speciality: referral.speciality ? this._phrutilService.decryptforServices(referral.speciality) : referral.speciality,
              phonE_NO: referral.phonE_NO ? this.maskPhoneNumber(this._phrutilService.decryptforServices(referral.phonE_NO)) : referral.phonE_NO,
              email: referral.email ? this._phrutilService.decryptforServices(referral.email) : referral.email,
              confirmeD_BY_PATIENT: referral.confirmeD_BY_PATIENT ? this._phrutilService.decryptforServices(referral.confirmeD_BY_PATIENT) : referral.confirmeD_BY_PATIENT,
              address: referral.address ? this._phrutilService.decryptforServices(referral.address) : referral.address,
              city: referral.city ? this._phrutilService.decryptforServices(referral.city) : referral.city,
              state: referral.state ? this._phrutilService.decryptforServices(referral.state) : referral.state,
              zip: referral.zip ? this._phrutilService.decryptforServices(referral.zip) : referral.zip,
              faX_NO: referral.faX_NO ? this.maskPhoneNumber(this._phrutilService.decryptforServices(referral.faX_NO)) : referral.faX_NO,
              referraL_SENDING_METHOD: referral.referraL_SENDING_METHOD ? this._phrutilService.decryptforServices(referral.referraL_SENDING_METHOD) : referral.referraL_SENDING_METHOD,
              direcT_ADDRESS: referral.direcT_ADDRESS ? this._phrutilService.decryptforServices(referral.direcT_ADDRESS) : referral.direcT_ADDRESS,
              senD_VIA_SMS: referral.senD_VIA_SMS ? this._phrutilService.decryptforServices(referral.senD_VIA_SMS) : referral.senD_VIA_SMS,
              senD_VIA_EMAIL: referral.senD_VIA_EMAIL ? this._phrutilService.decryptforServices(referral.senD_VIA_EMAIL) : referral.senD_VIA_EMAIL,

            };
          });

          this.getPatientReferralInfo.patientInsuranceInfo = res.data.patientInsuranceInfo.map((insuarnce: any) => {
            return {
              patienT_INSURANCE_ID: insuarnce.patienT_INSURANCE_ID ,
              co_Payment: insuarnce.co_Payment ,
              deductions: insuarnce.deductions ,
              effective_Date: insuarnce.effective_Date ,
              termination_Date: insuarnce.termination_Date ,
              group_Name: insuarnce.group_Name ,
              filing_indicator: insuarnce.filing_indicator ,
              cO_PAYMENT_PER: insuarnce.cO_PAYMENT_PER ,
              group_Number: insuarnce.group_Number ,
              allowed_Visits: insuarnce.allowed_Visits ,
              patienT_ACCOUNT: insuarnce.patienT_ACCOUNT ,
              prI_SEC_OTH_TYPE: insuarnce.prI_SEC_OTH_TYPE ,
              id: insuarnce.id ,
              policY_NUMBER: insuarnce.policY_NUMBER ,
              relationship: insuarnce.relationship ,
              date: insuarnce.date ,
              inspayeR_DESCRIPTION: insuarnce.inspayeR_DESCRIPTION ,
              subscriber: insuarnce.subscriber ,
              insurancE_ID: insuarnce.insurancE_ID ,
              insurancE_ADDRESS: insuarnce.insurancE_ADDRESS ,
              insurancE_CITY: insuarnce.insurancE_CITY ,
              insurancE_STATE: insuarnce.insurancE_STATE ,
              insurancE_ZIP: insuarnce.insurancE_ZIP ,
              relationshiP_DESCRIPTION: insuarnce.relationshiP_DESCRIPTION ,
              guarantoR_CODE: insuarnce.guarantoR_CODE ,
             
            };
          });
          if (this.getPatientReferralInfo.practicePhone) {
            this.phoneLink = "tel:+1" + this.getPatientReferralInfo.practicePhone;
            this.getPatientReferralInfo.practicePhone = this._phrutilService.maskingPhoneNumer(this.getPatientReferralInfo.practicePhone);
          }
          //this.GetPatientSelectedReferral(this.getPatientReferralInfo.patientAccount, this.getPatientReferralInfo.practiceCode, this.getPatientReferralInfo.referrals[0].referraL_ID);
          this.checkAndSaveSpecialty();
          this._phrutilService.setNavpracName(this.getPatientReferralInfo.practiceName);
          localStorage.setItem("ptAccount", this.getPatientReferralInfo.patientAccount);
          localStorage.setItem("prCode", this.getPatientReferralInfo.practiceCode);
          localStorage.setItem("prName", this.getPatientReferralInfo.practiceName);
          localStorage.setItem("zip", this.getPatientReferralInfo.zip);
          localStorage.setItem("city", this.getPatientReferralInfo.city);
          localStorage.setItem("state", this.getPatientReferralInfo.state);
          localStorage.setItem("prAddress", this.handleAddress(this.getPatientReferralInfo.practiceAddress));
          if (this.getPatientReferralInfo.patientPhone)
          localStorage.setItem("ptPhone", this._phrutilService.encrypt(this.getPatientReferralInfo.patientPhone));
          localStorage.setItem("prSP", this.speciality);
          localStorage.setItem("prfax", this.getPatientReferralInfo.practiceFax);
          localStorage.setItem("prPhone", this.getPatientReferralInfo.practicePhone);
          if (this.getPatientReferralInfo.firstName)
            localStorage.setItem("ptfname", this._phrutilService.encrypt(this.getPatientReferralInfo.firstName));
          if (this.getPatientReferralInfo.lastName)
          localStorage.setItem("ptlname", this._phrutilService.encrypt(this.getPatientReferralInfo.lastName));
          localStorage.setItem("ptAddress", this.getPatientReferralInfo.address);
          if (this.getPatientReferralInfo.dateOfBirth)
            localStorage.setItem("ptdob", this._phrutilService.encrypt(this.getPatientReferralInfo.dateOfBirth));
          if (this.getPatientReferralInfo.ssn) {
            const last4Digits = this.getPatientReferralInfo.ssn.slice(-4);
            //console.log(last4Digits);
            this.getPatientReferralInfo.ssn = last4Digits
            localStorage.setItem("ptssn", this._phrutilService.encrypt(this.getPatientReferralInfo.ssn));
          }
         // console.log("patient zip ", this.getPatientReferralInfo.zip);
         // console.log("practice Address ", this.getPatientReferralInfo.practiceAddress);
          if (this.getPatientReferralInfo.referrals) {
            let encryptdata = this._phrutilService.encrypt(this.getPatientReferralInfo.referrals);
            // console.log("encrypted data ", encryptdata);
            localStorage.setItem("referralData", encryptdata);
          }
          if (this.getPatientReferralInfo.patientInsuranceInfo) {
            let encryptinsurancedata = this._phrutilService.encrypt(this.getPatientReferralInfo.patientInsuranceInfo);
            // console.log("encrypted data ", encryptdata);
            localStorage.setItem("insuranceData", encryptinsurancedata);
          }

          // Log Rocket Implementation
          const LogRocket = require('logrocket/setup')({
            sdkServer: 'https://logrocket.carecloud.com',
            ingestServer: 'https://logrocket.carecloud.com'
          });
          LogRocket.init('carecloud/breeze-checkin');
          LogRocket.startNewSession();
          LogRocket.identify(this.getPatientReferralInfo.patientAccount, {
            name: this.getPatientReferralInfo.patientAccount,
            ///email: this.getPatientInfo.emailAddress,
            // Add your own custom user variables here, ie:
            subscriptionType: 'pro'
          });
       
        }
        else {
           $("#invalidLink-model").modal("show");
            return;
        }

      }
      else {
        $("#invalidLink-model").modal("show");
        return;
      }
    }, (error: any) => {
      this.spinner.hide();
      $("#invalidLink-model").modal("show");
      return;
    });
  }


  GetPatientSelectedReferral(patientAccount: any, practiceCode: any,referralId:any) {
    this.spinner.show();
    this.referralService.GetPatientSelectedReferral(patientAccount, practiceCode, referralId).subscribe((res: any) => {

      this.spinner.hide();
      //console.log("result ", res);
      if (res.statusCode == 200) {
        this.getSelectedReferralInfo = res.data.selectedReferrals as selectedReferrals[];
        if (this.getSelectedReferralInfo.length > 0) {
          if ((this.responseMessage.toLowerCase() == "referral data retrieved from referral_tracker" || this.responseMessage.toLowerCase() == 'referral has been sent')) {
            this.referralStatus = "sent";
            localStorage.setItem("refStatus", this.referralStatus);
          }
        } else {

          if ((this.responseMessage.toLowerCase() == "referral data retrieved from referral_tracker" || this.responseMessage.toLowerCase() == 'referral has been sent')) {
            this.referralStatus = "noSuggestedProvider";
            localStorage.setItem("refStatus", this.referralStatus);
          }
        }
      }
      else {
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
        //this._phrutilService.showError("Service is not available, please try later.");
      }

    },
      (error: any) => {
        this.spinner.hide();
        let text = "Service is not available, please try later.";
        this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
          text = translation;
        });
        this._phrutilService.showError(text);
       // this._phrutilService.showError("Service is not available, please try later.");
      })
  }


  checkAndSaveSpecialty() {
    const referrals = this.getPatientReferralInfo.referrals;
   // console.log("referral array ", referrals);
    if (referrals.length === 0) {

      this.speciality = '';
      return;
    }


    const firstReferralSpecialty = referrals[0].speciality;


    const allSameSpecialty = referrals.every(referral => referral.speciality === firstReferralSpecialty);

    if (allSameSpecialty) {

      this.speciality = firstReferralSpecialty;
    } else {

      this.speciality = '';  
    }
  }


  verifyPatient() {
    if (this.profileForm.valid) {
      const dobDay = this.profileForm.controls['dobDay'].value;
      const dobMonth = this.profileForm.controls['dobMonth'].value;

      const dobYear = this.profileForm.controls['dobyear'].value;
      const formattedDate = dobMonth + "/" + dobDay + "/" + dobYear;
     // console.log("formated date ", formattedDate);
     // console.log("date of birth ", this.getPatientReferralInfo.dateOfBirth);
      const formattedLocalDate = this.ConverttoLocalDate(formattedDate);
      const dob = this.ConverttoLocalDate(this.getPatientReferralInfo.dateOfBirth);

      // Compare the year, month, and day only
      const isSameDate = dob.getFullYear() === formattedLocalDate.getFullYear() &&
        dob.getMonth() === formattedLocalDate.getMonth() &&
        dob.getDate() === formattedLocalDate.getDate();

  //    console.log("Formatted date after: ", formattedLocalDate);
  //    console.log("Date of birth after: ", dob);
  //    console.log("same date: ", isSameDate);

      if (isSameDate) {
        this.isAuthenticated = true;
        localStorage.setItem("isAuth", this.isAuthenticated);
        //redirect to referral selection component
        console.log("inside submit");
        this.route.navigateByUrl('/referral');
      } else {
        this.isAuthenticated = false;
        localStorage.setItem("isAuth", this.isAuthenticated);
        $("#incorrectinfo-model").modal("show");
      }
    } else {
      this.profileForm.markAllAsTouched();
    }
  }

  maskPhoneNumber(phoneNo: any) {
    //mask phonenumber
    if (phoneNo == '' || phoneNo == null || phoneNo == undefined) {
      return '';
    }
    const ptPhoneNumber = phoneNo;
    const sanitizedptPhoneNumber = ptPhoneNumber.replace(/[^0-9]/g, ''); // Removes all non-numeric characters
    return this._phrutilService.maskingPhoneNumer(sanitizedptPhoneNumber)
  }

  handleAddress(address: string): string {
    // Regex to find ZIP code (5 or 9 digits)
    const zipRegex = /(\d{5})\d{4}|\d{5}/;

    // Search for a ZIP code in the address string
    const zipMatch = address.match(zipRegex);

    if (zipMatch) {
      // If a ZIP code is found, format it
      const formattedZipCode = this._phrutilService.maskingZipNum(zipMatch[0]);

      // Replace the original ZIP code in the address with the formatted version
      return address.replace(zipMatch[0], formattedZipCode);
    }

    // If no ZIP code found, return the address as is
    return address;
  }

  ConverttoLocalDate(date: any): Date {
    if (date instanceof Date) {
      // If it's already a Date object, no need to process further
      return date;
    }

    // Check if the string contains timezone info
    if (this.hasTimezone(date)) {
      // Remove the 'Z' or timezone information
      date = this.removeZ(date);
    }

    // Convert the resulting string to a Date object using moment.js
    return moment(date, ['MM/DD/YYYY']).toDate();
  }



  private hasTimezone(value: any) {
    if (typeof value !== 'string') return false;
    return (value.includes('T') || value.includes('t'));
  }

  private removeZ(value: any) {
    if (!value) return '';
    return value.replace(/z|Z/, '');
  }


  onlyCharAllow(event: any, type: any) {
    if (event.value.trim()) {
      let validname = event.value.replace(/[^a-zA-Z ]/g, "");
      event.value = validname;
    }
    else {
      event.value = event.value.trim();
      this.profileForm.controls[type].setValue(event.value);
    }
  }


}
